<template>
  <div>
    <NavBar />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <v-btn
          v-if="permissions.type_of_customer.write"
          class="v-primary mb-1"
          v-on:click="handleModalCreate"
        >
          <span class="fa fa-plus"></span> Novo
        </v-btn>
        <!-- Modal create -->
        <b-modal id="createTypeOfCustomer" hide-footer>
          <template v-slot:modal-title>Novo tipo de familiar</template>
          <div class="d-block">
            <div class="container">
              <form v-on:submit="create" method="post">
                <div class="row">
                  <WarningRequiredFields />
                  <ErrorsMessages :errors="errors" />
                  <div class="col-md-12">
                    <LabelRequiredField label="Nome" />
                    <input type="text" v-model="name" class="form-control" />
                  </div>
                  <div class="col-md-12 text-right">
                    <v-btn
                      :disabled="loadingCreate"
                      type="submit"
                      class="v-success"
                    >
                      <span class="fa fa-check"></span>
                      {{ loadingCreate ? "Carregando" : "Salvar" }}
                    </v-btn>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </b-modal>
        <!-- /Modal create -->
        <v-card>
          <v-card-title>
            Tipos de familiar
            <v-spacer />
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
            />
          </v-card-title>
          <v-data-table
            dense
            :headers="headers"
            :items="typeOfCustomers"
            :search="search"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [25, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            @click:row="handleClickRowTable"
          >
            <template v-slot:[`item.edit`]="{ item }">
              <!-- Modal alterar typeOfCustomer -->
              <b-modal :id="String(item.id)" hide-footer>
                <template v-slot:modal-title>Editar tipo de familiar</template>
                <div class="d-block">
                  <div class="container">
                    <b-overlay
                      :show="loadingTypeOfCustomerUpdate"
                      opacity="0.99"
                    >
                      <form v-on:submit="update" method="post">
                        <div class="row">
                          <WarningRequiredFields />
                          <ErrorsMessages :errors="errors" />
                          <div class="col-md-12">
                            <LabelRequiredField label="Nome" />
                            <input
                              :disabled="!permissions.type_of_customer.edit"
                              type="text"
                              v-model="name"
                              class="form-control"
                            />
                          </div>
                          <div class="col-md-12">
                            <h6>
                              <span class="text-muted">Criação:</span>
                              {{ formatDate(item.created_at) }}
                            </h6>
                            <h6>
                              <span class="text-muted">Última alteração:</span>
                              {{ formatDate(item.updated_at) }}
                            </h6>
                          </div>
                          <div class="col-md-12 text-right">
                            <v-btn
                              class="v-primary m-1"
                              @click="$bvModal.hide(String(item.id))"
                            >
                              <span class="fa fa-arrow-left"></span> Voltar
                            </v-btn>
                            <v-btn
                              v-if="permissions.type_of_customer.edit"
                              :disabled="loadingUpdate"
                              type="submit"
                              class="v-success m-1"
                            >
                              <span class="fa fa-check"></span>
                              {{ loadingUpdate ? "Carregando" : "Salvar" }}
                            </v-btn>
                            <v-btn
                              v-if="permissions.type_of_customer.remove"
                              class="v-danger m-1"
                              v-confirm="{
                                html: true,
                                loader: false,
                                ok: (dialog) =>
                                  deleteTypeOfCustomer(dialog, item),
                                cancel: () => {},
                                message:
                                  'Deseja realmente apagar o tipo de familiar? <hr /> Só pode apagar caso não exista vinculo do tipo de familiar com familiar!',
                                okText: 'Confirmar',
                                cancelText: 'Cancelar',
                              }"
                            >
                              <span class="fa fa-times-circle"></span> Apagar
                            </v-btn>
                          </div>
                        </div>
                      </form>
                    </b-overlay>
                  </div>
                </div>
              </b-modal>
              <!-- /Modal alterar typeOfCustomer -->
            </template>
          </v-data-table>
        </v-card>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import WarningRequiredFields from "../templates/components/WarningRequiredFields";
import LabelRequiredField from "../templates/components/LabelRequiredField";
import ErrorsMessages from "../templates/components/ErrorsMessages";
import NavBar from "../templates/NavBar";
import api from "../services/api";
import toast from "../components/ToastNotification";
import { formatDate } from "../functions/format";
import { adminData } from "../lib/functions";

export default {
  name: "TypeOfCustomer",
  components: {
    NavBar,
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      permissions: {},
      errors: [],
      search: "",
      headers: [
        { text: "Código", sortable: false, value: "id" },
        { text: "Nome", value: "name" },
        { align: "end", text: "", sortable: false, value: "edit" },
      ],
      typeOfCustomer: {},
      typeOfCustomers: [],
      id: "",
      name: "",
      loadingCreate: false,
      loadingUpdate: false,
      loadingTypeOfCustomerUpdate: false,
      loading: true,
    };
  },
  async created() {
    this.permissions = adminData().permissions;

    this.getTypeOfCustomers();
  },
  methods: {
    formatDate,
    handleClickRowTable(item) {
      this.errors = [];
      this.handleModalTypeOfCustomer(item.id);
      this.$bvModal.show(String(item.id));
    },
    async getTypeOfCustomers(page = 1) {
      try {
        this.loading = true;

        const response = await api.get("/types-of-customers/paginate", {
          params: { page },
        });

        const { types } = response.data;

        this.typeOfCustomers = types;
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async create(event) {
      try {
        event.preventDefault();

        this.loadingCreate = true;

        const { name } = this;

        let params = {
          name,
        };

        const response = await api.post("/type-of-customer", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide("createTypeOfCustomer");
          this.getTypeOfCustomers();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingCreate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async update(event) {
      try {
        event.preventDefault();

        this.loadingUpdate = true;

        const { id, name } = this;

        let params = {
          id,
          name,
        };

        const response = await api.patch("/type-of-customer", params);

        const { error, errors, message } = response.data;

        if (!error) {
          this.$bvModal.hide(String(id));
          this.getTypeOfCustomers();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
        this.loadingUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    handleModalCreate() {
      this.errors = [];
      this.name = "";
      this.$bvModal.show("createTypeOfCustomer");
    },
    async handleModalTypeOfCustomer(id) {
      try {
        this.loadingTypeOfCustomerUpdate = true;

        this.id = id;

        const response = await api.get("/type-of-customer", {
          params: { id },
        });

        const { type } = response.data;

        this.typeOfCustomer = type;
        this.id = type.id;
        this.name = type.name;
        this.loadingTypeOfCustomerUpdate = false;
      } catch (error) {
        console.log(error);
      }
    },
    async deleteTypeOfCustomer(dialog, typeOfCustomer) {
      try {
        const { id } = typeOfCustomer;

        let data = { id };

        const response = await api.delete("/type-of-customer", {
          data,
        });

        const { error, errors, message } = response.data;

        if (!error) {
          this.getTypeOfCustomers();
          this.errors = [];
          toast(message, "success");
        } else {
          this.errors = errors;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>